const experiment = {
    state: {
        experimentId:"",
        experimentName: "", //实验名称
        baseBusinessCode: "", //业务类型
        baseSegmentCode: "", //学段
        baseSubjectCode: "", //科目
        baseGradeCode: "", //年级
        baseDistrictCode:"",//校区
        baseExperimentTypeCode: "", //实验类型
        baseTextbookCode: "", //教材版本
        experimentTags: [], //实验标签
        knowledgeTreeId: "", //知识树
        knowledgeTreeName: "", //知识树
        knowledges:"",
        source:"2"//来源 1标准 2 校本 3个人
    },
    mutations: {
        setExperiment(state,expForm){
            state.experimentId = expForm.experimentId
            state.experimentName = expForm.experimentName
            state.baseBusinessCode = expForm.baseBusinessCode
            state.baseSegmentCode = expForm.baseSegmentCode
            state.baseSubjectCode = expForm.baseSubjectCode
            state.baseGradeCode = expForm.baseGradeCode
            state.baseExperimentTypeCode = expForm.baseExperimentTypeCode
            state.baseTextbookCode = expForm.baseTextbookCode
            state.experimentTags = expForm.experimentTags
            state.baseDistrictCode = expForm.baseDistrictCode
            state.knowledgeTreeId = expForm.knowledgeTreeId
            state.knowledgeTreeName = expForm.knowledgeTreeName
            state.knowledges = expForm.knowledges
            state.source = expForm.source
        }
    }
  }
  
  export default experiment